import { Box, styled } from '@withjoy/joykit';

export const SpamRowContainer = styled(Box)`
  padding: 0.7rem;
  margin: 0px;

  background-color: rgb(235, 235, 235);
  border-top: 1px solid black;
  border-bottom: 1px solid black;

  margin-top: -1px;
`;
